/**
 * DetectionPills - Vulnerability detection badge
 *
 * `showCounts` controls whether counts are displayed (cards: yes, overview header: no).
 *
 * Atomic level: Molecule
 */

import React from 'react';

interface DetectionPillsProps {
  vulnerableCustomersCount?: number;
  showCounts?: boolean;
  className?: string;
}

const DetectionPills: React.FC<DetectionPillsProps> = ({
  vulnerableCustomersCount = 0,
  showCounts = true,
  className = '',
}) => {
  return (
    <div className={`flex gap-1 flex-wrap ${className}`}>
      <span className="inline-flex items-center gap-0.5 text-[9px] font-semibold px-2 py-0.5 rounded-full border border-[rgba(88,0,149,0.12)] bg-[rgba(88,0,149,0.05)] text-[#580095]">
        Vulnerability
        {showCounts && <span className="font-bold">{vulnerableCustomersCount}</span>}
      </span>
    </div>
  );
};

export { DetectionPills };
export type { DetectionPillsProps };
